<!-- Contenedor principal -->
<div [ngClass]="{ 'gantt-wrapper': isFullscreen }">
  <div class="table-body">
    <div class="no-filters-container" *ngIf="!selectedZone && !loadingGantt">
      <span class="title-no-filters">
        {{ "service_manager.gantt.select_zone_and_date" | translate }}
      </span>
    </div>

    <!-- Opciones -->
    <div class="table-body-options">
      <!-- Búsqueda -->
      <div class="search-bar">
        <img
          src="../../../assets/icons/search-icon.svg"
          alt="Search Icon"
          class="search-icon"
        />
        <input
          type="text"
          placeholder="{{ 'service_manager.gantt.search_text' | translate }}"
          class="search-bar-input filter-ctrl"
          (input)="filterData()"
          [(ngModel)]="searchTerm"
        />
      </div>

      <ng-select
        [items]="zones"
        bindLabel="zoneName"
        bindValue="zoneId"
        [multiple]="false"
        [clearable]="false"
        [(ngModel)]="selectedZone"
        class="custom_zone_select custom_select filter-ctrl"
        (change)="onZoneChange()"
        placeholder="{{ 'service_manager.gantt.zone_input' | translate }}"
        [dropdownPosition]="'bottom'"
      >
      </ng-select>

      <ng-select
        class="custom_select"
        [items]="operatorEmployeeOptions"
        [(ngModel)]="selectedIsInternalEmployee"
        bindLabel="labelKey"
        bindValue="value"
        [clearable]="false"
        [searchable]="false"
        [placeholder]="'service_manager.gantt.operator_type_label' | translate"
        (change)="onOperatorEmployeeChange()"
      >
        <ng-template ng-label-tmp let-item="item">{{
          item.labelKey | translate
        }}</ng-template>
        <ng-template ng-option-tmp let-item="item">{{
          item.labelKey | translate
        }}</ng-template>
      </ng-select>

      <ng-select
        class="custom_select"
        [items]="driverTypeOptions"
        [(ngModel)]="selectedDriverType"
        [multiple]="false"
        bindLabel="labelKey"
        bindValue="value"
        [clearable]="false"
        [searchable]="false"
        [placeholder]="'service_manager.gantt.driver_type_label' | translate"
        (change)="onDriverTypeChange()"
      >
        <ng-template ng-label-tmp let-item="item">{{
          item.labelKey | translate
        }}</ng-template>
        <ng-template ng-option-tmp let-item="item">{{
          item.labelKey | translate
        }}</ng-template>
        </ng-select>
      <div class="gantt-flex-spacer"></div>
      <div class="gantt-right-controls">
        <div class="master" (click)="selectToday()">
          <div class="text">
            <div class="value">
              {{ "service_manager.gantt.today" | translate }}
            </div>
          </div>
          <div class="tui-badge"></div>
        </div>

        <tui-input-date
          class="date-selector h-32"
          [(ngModel)]="selectedDate"
          tuiTextfieldSize="s"
          [tuiTextfieldLabelOutside]="true"
          [attr.placeholder]="'sweeper_car.date_placeholder' | translate"
          (ngModelChange)="onDateChange()"
        >
          {{ "service_manager.gantt.date_input" | translate }}
        </tui-input-date>

        <ng-select
          class="custom_select"
          [items]="intervalOptions"
          [(ngModel)]="selectedInterval"
          bindLabel="labelKey"
          [clearable]="false"
          [searchable]="false"
          (change)="onIntervalChange($event)"
        >
          <ng-template ng-label-tmp let-item="item">{{
            item.labelKey | translate
          }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{
            item.labelKey | translate
          }}</ng-template>
        </ng-select>

        <button
          [tuiHint]="
            isFullscreen
              ? ('service_manager.gantt.exit_fullscreen_tooltip' | translate)
              : ('service_manager.gantt.fullscreen_tooltip' | translate)
          "
          tuiHintDirection="top"
          class="fullscreen-toggle-btn"
          (click)="toggleFullscreen()"
        >
          <img
            [src]="
              isFullscreen
                ? 'assets/icons/collapse-icon.svg'
                : 'assets/icons/expand-icon.svg'
            "
            alt="Fullscreen toggle"
          />
        </button>

    </div>

    <!-- Alert Servicios sin provider -->
    <div
      class="no-providers-alert-container"
      *ngIf="NoProviderServices?.length"
    >
      <img
        class="no-provider-alert-icon"
        src="../../../assets/icons/icons_solid_exclamation_circle.webp"
        alt=""
      />
      <p class="no-provider-alert-text">
        {{ "NO_PROVIDER_SERVICE.GANTT.0" | translate }}
        <span class="no-provider-alert-text-bolt"
          >{{ NoProviderServices.length }}
          {{ "NO_PROVIDER_SERVICE.GANTT.1" | translate }}</span
        >
        {{ "NO_PROVIDER_SERVICE.GANTT.2" | translate }}
        <span
          class="no-provider-alert-text-bolt-under"
          (click)="openNoProvidersSide()"
        >
          {{ "NO_PROVIDER_SERVICE.GANTT.3" | translate }}
        </span>
      </p>
    </div>

    <!-- Gantt -->
    <div
      #father
      class="d-flex"
      [ngClass]="{
        'gantt-main-container-fullscreen': isFullscreen,
        'gantt-main-container': !isFullscreen,
        'no-services-scroll': ganttData.length && !hasAnyTasks
      }"
    >
      <!-- Columna de operadores -->
      <div class="gantt-main-container2" *ngIf="ganttData.length">
        <div class="gantt-header">
          <div class="gantt-header-cell2">
            {{ "service_manager.gantt.drivers" | translate }}
          </div>
        </div>

        <div
          #div1
          class="gantt-row2 justify-content-center"
          [style.height]="getRowHeight(row)"
          *ngFor="let row of ganttData; let i = index; trackBy: trackByRow"
          [ngClass]="{
            'white-background': i % 2 === 0,
            'gray-background': i % 2 !== 0
          }"
        >
          <ng-container *ngIf="row.driver?.[0] as d">
            <div class="driver-name-row">
              <div
                class="operator-name-label"
                [tuiHint]="d.fullName"
                tuiHintDirection="right"
              >
                {{ d.fullName }}
              </div>
              <span
                *ngIf="d.driverId"
                class="driver-internal-badge"
                [class.driver-internal-badge--external]="!d.isInternal"
              >
                {{
                  d.isInternal
                    ? ("service_manager.gantt.operator_type_internal" | translate)
                    : ("service_manager.gantt.operator_type_external" | translate)
                }}
              </span>
            </div>

            <div
              *ngIf="d.workdayStartTime.seconds && d.workdayEndTime.seconds"
              class="operator-role"
            >
              <ng-container *ngIf="hasSecondShift(d); else singleShiftLine">
                {{ getFormattedTime(d.workdayStartTime.seconds) }} -
                {{ getFormattedTime(d.workdayEndTime.seconds) }}
                &nbsp;|&nbsp;
                {{ getFormattedTime(d.secondShiftWorkdayStartTime?.seconds) }} -
                {{ getFormattedTime(d.secondShiftWorkdayEndTime?.seconds) }}
              </ng-container>

              <ng-template #singleShiftLine>
                {{ getFormattedTime(d.workdayStartTime.seconds) }} -
                {{ getFormattedTime(d.workdayEndTime.seconds) }}
                <ng-container *ngIf="getDriverTypeTranslationKey(d.operatorType) as typeKey">
                  &nbsp;·&nbsp;{{ typeKey | translate }}
                </ng-container>
              </ng-template>
            </div>

            <div
              *ngIf="hasSecondShift(d)"
              class="operator-role operator-role--type-secondary"
            >
              <ng-container *ngIf="getDriverTypeTranslationKey(d.operatorType) as typeKey">
                {{ typeKey | translate }}
              </ng-container>
            </div>

            <button
              *ngIf="isSweeperDriver(row)"
              class="download-route-btn"
              [disabled]="downloadingRows.has(row.key)"
              (click)="onDownloadRoute(d, row)"
            >
              <tui-loader
                *ngIf="downloadingRows.has(row.key); else downloadIcon"
                size="xs"
                class="download-route-loader"
              ></tui-loader>
              <ng-template #downloadIcon>
                <tui-svg src="tuiIconDownload" class="download-route-icon"></tui-svg>
              </ng-template>
              {{ "service_manager.gantt.download_route" | translate }}
            </button>
          </ng-container>
        </div>
      </div>

      <!-- Lienzo del diagrama -->
      <div class="gantt-container" *ngIf="ganttData.length; else emptyGantt">
        <ng-container *ngIf="hasAnyTasks; else noServicesWithDrivers">
          <!-- Grid vertical -->
          <div class="gantt-time-grid">
            <div
              class="gantt-time-grid-cell"
              *ngFor="let hour of hours"
            ></div>
          </div>

          <!-- Hora actual -->
          <div class="current-time-container">
            <div class="current-time" [style.left.px]="currentLeftPx"></div>
          </div>

          <!-- Cabecera -->
          <div class="gantt-header">
            <div
              class="gantt-header-cell"
              *ngFor="let hour of hours"
            >
              {{ hour }}
            </div>
          </div>

          <!-- Cuerpo -->
          <div class="gantt-body">
            <div
              #div2
              class="gantt-row"
              [style.height]="getRowHeight(row)"
              *ngFor="let row of ganttData; let i = index; trackBy: trackByRow"
              [ngClass]="{
                'white-background': i % 2 === 0,
                'gray-background': i % 2 !== 0
              }"
            >
              <ng-container
                *ngIf="getFlattenedTasks(row.value.data) as flatTasks"
              >
                <ng-container
                  *ngFor="let task of flatTasks; trackBy: trackByTask"
                >
                  <div
                    class="gantt-task"
                    [ngStyle]="getPositionStyle(task)"
                    [ngClass]="[
                      getStatusStyle(task, task.nodeType),
                      getStatusBlock(task.isNodeLockedForDriverAssignation)
                    ]"
                    [style.border]="
                      task.isUrgent
                        ? '2px solid #FFCC00 !important'
                        : '1px solid rgba(225, 225, 225, 0.6)'
                    "
                    title="{{ task.licensePlate }} - {{ task.orderHash }}"
                    (click)="openSidebar(task)"
                  >
                    <div class="delay-icons" *ngIf="task.isServiceDelayed">
                      <img src="assets/icons/delay_clock_icon.webp" alt="" />
                      <img
                        *ngIf="!isValidGuid(task.delayReasonGuid)"
                        src="assets/icons/warning_yellow_triangle.webp"
                        alt=""
                      />
                    </div>

                    <div class="gantt-task-data">
                      <div class="gantt-task-info">
                        <span
                          *ngIf="task.nodeType === 'OPERATIVE_NODE'"
                          class="gantt-task-data-service"
                        >
                          {{ task.licensePlate || '-' }}
                        </span>
                        <span
                          *ngIf="task.nodeType === 'TRANSPORT_NODE'"
                          class="gantt-task-data-service"
                        >
                          {{
                            'service_manager.gantt.publicTransport' | translate
                          }}
                        </span>
                        <span
                          *ngIf="task.nodeType === 'SWEEPER_NODE'"
                          class="gantt-task-data-service"
                        >
                          {{ 'service_manager.gantt.transferCar' | translate }}
                        </span>

                         <span
                          *ngIf="task.nodeType === 'VEHICLE_NODE'"
                          class="gantt-task-data-service"
                        >
                          {{ 'service_manager.gantt.vehicle' | translate }}
                        </span>

                        <img
                          *ngIf="task.hasPriority"
                          src="../../../assets/icons/priority-service.svg"
                          alt="Priority"
                          class="icon-task"
                        />
                        <tui-icon
                          *ngIf="task.isNodeLockedForDriverAssignation"
                          icon="tuiIconLock"
                          [style.color]="'black'"
                          class="icon-task"
                        ></tui-icon>

                        <img
                          *ngIf="task.isUrgent"
                          src="../../../assets/icons/alert-urgent.svg"
                          alt="Urgent"
                          class="icon-task icon-task-urgent"
                          title="{{ 'service_manager.gantt.urgent' | translate }}"
                        />

                        <img
                          [src]="getIcon(task.verticalType, task.nodeType)"
                          alt="Task Icon"
                          class="icon-task"
                        />
                        <span
                          *ngIf="task.nodeType === 'OPERATIVE_NODE'"
                          class="minutes"
                        >
                          {{ getChassisLabel(task.vehicleChassis) || '-' }}
                        </span>

                      </div>

                      <div
                        *ngIf="task.nodeType === 'OPERATIVE_NODE'"
                        class="minutes gantt-task-info"
                      >
                        {{ getProductTypeLabel(task.productName) }}
                        <ng-container
                          *ngIf="
                            isCopec &&
                            getMobilityServiceTypeLabelKey(
                              task.serviceTypeMobility
                            ) as mobilityKey
                          "
                        >
                          · {{ mobilityKey | translate }}
                        </ng-container>
                      </div>
                      <div
                        *ngIf="task.nodeType === 'TRANSPORT_NODE' || task.nodeType === 'VEHICLE_NODE'"
                        class="minutes gantt-task-info"
                      >
                        {{ task.totalTime || '-' }}
                      </div>
                      <div
                        *ngIf="task.nodeType === 'SWEEPER_NODE'"
                        class="minutes gantt-task-info"
                      >
                        {{
                          (task.driverName || '-') +
                            ' · ' +
                            (task.totalTime || '-')
                        }}
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>

      <ng-template #noServicesWithDrivers>
        <div class="gantt-body no-services-body">
          <div
            #div2
            class="gantt-row"
            [style.height]="getRowHeight(row)"
            *ngFor="let row of ganttData; let i = index; trackBy: trackByRow"
            [ngClass]="{
              'white-background': i % 2 === 0,
              'gray-background': i % 2 !== 0
            }"
          ></div>
        </div>
        <div class="no-services-with-drivers-overlay">
          <span class="title-no-services">
            {{ 'service_manager.gantt.no_services_header' | translate }}
          </span>
          <p class="text-center">
            {{ 'service_manager.gantt.no_services_text' | translate }}
          </p>
        </div>
      </ng-template>

      <!-- Vacío -->
      <ng-template #emptyGantt>
        <div class="no-services-container" *ngIf="!loadingGantt">
          <ng-container *ngIf="!selectedZone">
            <span class="title-no-services">{{
              "service_manager.gantt.select_zone_and_date" | translate
            }}</span>
            <div class="text-center mt-2">
              <p *ngIf="!selectedZone">
                {{ "service_manager.gantt.please_select_zone" | translate }}
              </p>
              <p *ngIf="!selectedDate">
                {{ "service_manager.gantt.please_select_date" | translate }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="selectedZone && selectedDate">
            <span *ngIf="noMatches" class="title-no-services">{{
              "service_manager.gantt.no_driver_found" | translate
            }}</span>
            <ng-container *ngIf="!noMatches">
              <span class="title-no-services">{{
                "service_manager.gantt.no_services_header" | translate
              }}</span>
              <p class="text-center">
                {{ "service_manager.gantt.no_services_text" | translate }}
              </p>
            </ng-container>
          </ng-container>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<!-- <div
  id="loader"
  *ngIf="isLoading || loadingGantt"
  role="status"
  aria-live="polite"
  class="loader-container"
>
  <img
    class="img_loader"
    src="../../../assets/logo-loading.gif"
    alt="{{ 'comercial.clients.loading' | translate }}"
  />
</div> -->
